// extracted by mini-css-extract-plugin
module.exports = {"blocked":"b_b","loader":"b_c","blog":"b_d","blog__categoryItem__wrap":"b_f"};